import { money } from "@/lib/format";

/**
 * Visual progress of the current payroll period.
 * @param saldo object returned by the API (days_worked, period_days, gross_accrued, period_salary)
 * @param compact when true uses smaller typography (table rows)
 */
export default function SaldoProgressBar({ saldo, compact = false }) {
  if (!saldo) return null;
  const {
    days_worked = 0,
    period_days = 15,
    gross_accrued = 0,
    period_salary = 0,
  } = saldo;

  // Calendar (natural) days. Weekends count as accrued.
  const denom = period_days || 15;
  const pct = denom > 0 ? Math.min(100, Math.max(0, (days_worked / denom) * 100)) : 0;
  const denomLabel = denom;

  return (
    <div className="w-full" data-testid="saldo-progress">
      <div
        className={`relative w-full bg-[#E2E8F0] rounded-full overflow-hidden ${compact ? "h-1.5" : "h-2"}`}
      >
        <div
          className="h-full bg-[#1D9E75] rounded-full transition-[width] duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div
        className={`mt-1.5 tabular-nums ${compact ? "text-[11px]" : "text-xs"} text-[#64748B] flex items-center gap-1.5`}
      >
        <span className="font-semibold text-[#0F172A]">
          {days_worked}/{denomLabel} días
        </span>
        <span className="text-[#CBD5E1]">·</span>
        <span>
          <span className="font-semibold text-[#147D5C]">{money(gross_accrued)}</span>
          {" devengado de "}
          <span className="font-medium text-[#334155]">{money(period_salary)}</span>
        </span>
      </div>
    </div>
  );
}
